import axios from "axios";
import { getSsoLegalSimpliEndPoint } from "../Services/base-url/api-constants";
import DocBuilderService from "../Services/DocBuilderService";
import { blobSignature, downloadCounter } from "./general-config";

export const goToDashboardAfterDownload = (isGotoDashboard: boolean) => {
  if (isGotoDashboard) {
    window.location.href = getSsoLegalSimpliEndPoint + "dashboard";
  }
};

export const goToDashboardSettings = () => {
  window.location.href = getSsoLegalSimpliEndPoint + "dashboard/settings";
};

export const downloadDocument = (
  docGuid: string,
  conversionType: string,
  toggleDownloadLoaderModal: string,
  downloadErrorMessage: string,
  isRequestForPrint: boolean,
  isGotoDashboard: boolean,
  setShowLoader: (p: string) => void
) => {
  if (docGuid != undefined) {
    // return getConversionStatus("276b7e7c-c9ae-482c-9dc7-c8302c3c05a4");
    return DocBuilderService.DownloadDocument(docGuid, conversionType, "true")
      .then((response: any) => {
        if (response) {
          if (response.conversionId !== "") {
            //appLogger.log("conversionId ", response.conversionId);
            let timer = 0;
            var e = setInterval(() => {
              timer += 1;
              getConversionStatus(docGuid, response.conversionId).then((responseStatus: any) => {
                if (!!responseStatus && responseStatus.conversionStatus == "COMPLETED") {
                  clearInterval(e);
                  // downloadErrorMessage("");
                  // toggleDownloadLoaderModal();
                  // deleteCookie("regenrateDoc");
                  // NOTE :: Clean cookie ... regenrateDoc

                  downloadPDF(responseStatus.docDownload, isRequestForPrint, isGotoDashboard, setShowLoader);
                } else if (
                  !!responseStatus &&
                  (responseStatus.conversionStatus == "NONE" || responseStatus.conversionStatus == "ERROR")
                ) {
                  //downloadErrorMessage("error");
                  setShowLoader("d-none");
                  goToDashboardAfterDownload(isGotoDashboard);
                  clearInterval(e);
                } else if (responseStatus == null || responseStatus == undefined) {
                  //downloadErrorMessage("error");
                  setShowLoader("d-none");
                  goToDashboardAfterDownload(isGotoDashboard);
                  clearInterval(e);
                } else if (timer === downloadCounter) {
                  //downloadErrorMessage("error");
                  setShowLoader("d-none");
                  goToDashboardAfterDownload(isGotoDashboard);
                  clearInterval(e);
                }
              });
            }, 2000);
          }
        } else {
          setShowLoader("d-none");
        }
        return response;
      })
      .catch((error) => {
        setShowLoader("d-none");
        // downloadErrorMessage("error");
        // appLogger.log("inside Download Resume error", error);
      });
  } else {
    setShowLoader("d-none");
    //appLogger.log("Invalid Document Id");
  }
};

export function getConversionStatus(documentId: string, conversionId: string) {
  return DocBuilderService.ConversionStatus(documentId, conversionId)
    .then((response) => {
      if (response) {
      }
      return response;
    })
    .catch((error) => {
      // appLogger.log("inside Conversion Resume error", error);
    });
}

const downloadUsingBlobPath = async (documentBlobPath: string) => {
  //download single file as blob
  const resp = await axios.get(documentBlobPath + blobSignature(), {
    responseType: "blob",
  });
  //return array buffer of blob file as we want to modify the file name
  return await resp.data.arrayBuffer();
};

const downloadPDF = async (
  docDownload: any,
  isRequestForPrint: boolean,
  isGotoDashboard: boolean,
  setShowLoader: (p: string) => void
) => {
  const respByteArray = await downloadUsingBlobPath(docDownload.documentBlobPath);
  var blob = new Blob([respByteArray], { type: "application/pdf" });
  // let byteChar = atob(docDownload.document);
  // let byteArray = new Array(byteChar.length);
  // for (let i = 0; i < byteChar.length; i++) {
  //   byteArray[i] = byteChar.charCodeAt(i);
  // }
  // let uIntArray = new Uint8Array(byteArray);
  // var blob = new Blob([uIntArray], {
  //   type: "application/pdf",
  // }); // change resultByte to bytes
  if (isRequestForPrint) {
    let pdfUrl = URL.createObjectURL(blob);
    if (!!pdfUrl) {
      let printwWindow = window.open(pdfUrl);
      //printwWindow.print();
    }
    //TODO - Message for print error
  } else {
    let link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${docDownload.documentName}.pdf`;
    link.click();
  }
  setShowLoader("d-none");
  goToDashboardAfterDownload(isGotoDashboard);
};
